import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js'

export const digits = (value: string): string => value.replace(/\D/g, '')

/** Generic phone formatting */
export const formatPhone = (e164String) => {
  if (!e164String) return ''

  const phone = parsePhoneNumberFromString(e164String)
  return (
    !phone ? ''
    : phone.countryCallingCode === '1' ? phone.formatNational()
    : phone.formatInternational()
  )
}

// Outputs (XXX) XXX - XXXX
export const formatPhoneInput = (input: string): string => {
  let d = digits(input)

  // Prevent '1' or '0' as the first digit
  if (d.startsWith('1') || d.startsWith('0')) {
    d = d.slice(1)
  }

  // Limit to 10 digits
  d = d.slice(0, 10)

  if (d.length === 0) {
    return ''
  }

  if (d.length < 4) {
    return `(${d}`
  }

  if (d.length < 7) {
    return `(${d.slice(0, 3)}) ${d.slice(3)}`
  }

  return `(${d.slice(0, 3)}) ${d.slice(3, 6)} - ${d.slice(6)}`
}

export const filterNumbersAndSpaces = (value: string): string => value.replace(/[^\d\s]/g, '')

export const isValidUSPhoneNumber = (value?: string | null) =>
  value && typeof value === 'string' && value.startsWith('+1') && isValidPhoneNumber(value, 'US')
